module.exports = __webpack_public_path__ + "static/img/s46.72a92209.png";